export default __webpack_public_path__ + "static/blast_cast-3f3b294503e62dad103f9b0eb2850ae3.svg";